import Login from "./pages/login/login";
import Logout from "./pages/logout/logout";
import Admin from "./pages/admin/admin";

const Auth = { Login, Logout, Admin };

export default Auth;
